var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{on:{"click":function($event){return _vm.$router.push({ name: 'app-FeaturedEvents' })}}},[_vm._v(" Return to gallery ")])],1)],1),_c('ImagesGallery',{attrs:{"images":_vm.eventImages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }